define([], () => {

    function renderHelp () {
        this.$('a.help:not(.help-rendered)').addClass('help-rendered').
            popover({html: true, container: 'body'}).
            click(
                function () {
                    const el = $(this);
                    const body = $('body');
                    const popover = $('.popover');
                    const onPopoverClick = function (event) {
                        return event.target.tagName.toLowerCase() === 'a' ||
                            event.target.parentNode.tagName.toLowerCase() === 'a';
                    };

                    $('a', popover).attr('target', '_blank').
                        append(
                            $('<i>').addClass('icon-external-link').
                                css(
                                    {'font-size': '9px', 'margin-left': '2px'})
                        );

                    $('<div>').addClass('drop-mask').
                        appendTo(body).
                        on('click', function () {
                            el.popover('hide');
                            $(this).remove();
                            popover.off('click', onPopoverClick);
                            return false;
                        });

                    popover.on('click', onPopoverClick);
                    return false;
                });
    }

    return {
        renderHelp
    };
});
